import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import InternalGate from './pages/InternalGate'
import { initMonitoring } from './lib/monitoring'
import './index.css'

initMonitoring()

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <InternalGate><App /></InternalGate>
  </React.StrictMode>
)
